import { useState } from "react";
import getTeams from "api/getTeams.js";
import fetchHighScores from "api/fetchHighScores.js";
import { ELocations } from "enums/appConfig.js";
import "./index.css";
import { useEffectHookOnGeneralBoard } from "hooks/useEffectHookOnGeneralBoard.js";
import GeneralTeamBoard from "components/generalTeamBoard";
import { testIds } from "enums/testIds";

/**
 * @name GeneralBoard
 * @param {*} props
 * @param {*} location
 * @returns the general board based on the location
 */
const GeneralBoard = (props) => {
  const [teams, setTeams] = useState([]);
  const getTeamsData = async (location) => {
    const data = await getTeams({ location });
    setTeams(data);
  };

  useEffectHookOnGeneralBoard(
    props,
    ELocations,
    fetchHighScores,
    setTeams,
    getTeamsData
  );

  const leftColumnTeams = teams.filter((_, index) => index % 2 === 0);
  const rightColumnTeams = teams.filter((_, index) => index % 2 !== 0);

  return (
    <div className="general-board-wrapper">
      <div className="general-board-columns">
        <div className="general-board-column">
          <div className="general-board-grid-header">
            <div className="header-item" aria-label={testIds.room_header}>
              ROOM
            </div>
            <div className="header-item" aria-label={testIds.team_name_header}>
              TEAM NAME
            </div>
            <div
              className="header-item"
              aria-label={testIds.escape_time_header}
            >
              ESCAPE TIME
            </div>
          </div>
          <div className="general-board-container">
            {leftColumnTeams.map((team) => (
              <GeneralTeamBoard key={team.room_name} data={team} />
            ))}
          </div>
        </div>
        <div className="general-board-column">
          <div className="general-board-grid-header hide">
            <div className="header-item" aria-label={testIds.room_header}>
              ROOM
            </div>
            <div className="header-item" aria-label={testIds.team_name_header}>
              TEAM NAME
            </div>
            <div
              className="header-item"
              aria-label={testIds.escape_time_header}
            >
              ESCAPE TIME
            </div>
          </div>
          <div className="general-board-container">
            {rightColumnTeams.map((team) => (
              <GeneralTeamBoard key={team.room_name} data={team} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralBoard;
